module.exports = __webpack_public_path__ + "media/images/shop/photo_thumbnail2-1797cff69451e478c14ac669bd20315b.jpg";